import { render } from "./Dates.vue?vue&type=template&id=56b21a80"
import script from "./Dates.vue?vue&type=script&lang=js"
export * from "./Dates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__